import { useAuth } from "@/context/AuthProvider";
import { useEffect, useState } from "react";

export const useEmailConfirmation = () => {
  const { user } = useAuth();
  const [showEmailConfirmation, setShowEmailConfirmation] = useState(false);

  // Verificar se o usuário precisa confirmar o email
  useEffect(() => {
    if (user && !user.isEmailVerified) {
      setShowEmailConfirmation(true);
    }
  }, [user]);

  const handleEmailConfirmationSuccess = () => {
    setShowEmailConfirmation(false);
    // Pode adicionar um toast ou notificação de sucesso aqui
    console.log("Email confirmado com sucesso!");
  };

  const handleEmailConfirmationPostpone = () => {
    setShowEmailConfirmation(false);
    // Pode adicionar uma notificação de que o usuário pode confirmar depois
    console.log("Confirmação de email adiada");
  };

  const handleCloseEmailConfirmation = () => {
    setShowEmailConfirmation(false);
  };

  return {
    showEmailConfirmation,
    handleEmailConfirmationSuccess,
    handleEmailConfirmationPostpone,
    handleCloseEmailConfirmation,
  };
}; 